import PaymentCardView from './PaymentCardView';

export default function PaymentCard({ title, subtitle, IconComponent, handleSelected, selected }) {
    return <PaymentCardView {...{ title, subtitle, IconComponent, handleSelected, selected }} />;
}
